<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid filterGrid--three">
          <div class="filterItem">
            <span class="searchText">名称</span>
            <el-input
              class="filterControl"
              placeholder="试着输入点什么"
              prefix-icon="el-icon-search"
              :value="name"
              size="small"
              clearable
              @input="$emit('update:name', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">用户 id</span>
            <el-input
              class="filterControl"
              placeholder="试着输入点什么"
              prefix-icon="el-icon-search"
              :value="uid"
              size="small"
              clearable
              @input="$emit('update:uid', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">角色类型</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="roleType"
              placeholder="请选择"
              size="small"
              clearable
              filterable
              @change="$emit('update:roleType', $event)"
            >
              <el-option label="PGC" :value="1" />
              <el-option label="UGC" :value="2" />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiRoleReviewListFilterPanel',
  props: {
    name: { type: String, default: '' },
    uid: { type: String, default: '' },
    roleType: { type: [String, Number], default: '' },
    activeFilterCount: { type: Number, default: 0 },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';
@import '../../resourceManage/genericResourceManage/linkListFilterPanel.css';
</style>